import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_CANCELLED_ALERT_QUERY = graphql(/* GraphQL */ `
  query NegotiationCaseCancelledAlert($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        status
        cancellationReason
        cancellationReasonText
      }
    }
  }
`);
